import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types (espelham apps/server/src/painel/painel.types.ts)

export type Destino =
    | 'dashboards'
    | 'campanha'
    | 'cadastroLote'
    | 'grupoManual'
    | 'bloqueios'
    | 'templates'
    | 'mensagemDireta'
    | 'simulador'

export type NivelAlerta = 'erro' | 'atencao' | 'info'

export type Alerta = {
    id: string
    nivel: NivelAlerta
    titulo: string
    detalhe?: string
    destino?: Destino
}

export type Numero = {
    id: string
    rotulo: string
    valor: number
    detalhe?: string
    percentual?: boolean
    destino?: Destino
}

export type Painel = {
    geradoEm: string
    /** Os blocos que o papel acompanha; com algum além das consultas, há o que pode pedir atenção. */
    blocos: string[]
    alertas: Alerta[]
    numeros: Numero[]
    indisponiveis: string[]
}

/** Um módulo que o papel pode abrir. */
export type Atalho = {
    destino: Destino
    nome: string
    descricao: string
}

// :: Scopes

@Observable
export class HeaderScope extends Scope {}

@Observable
export class OverviewScope extends Scope {
    readonly header = new HeaderScope()

    @observe() saudacao = ''
    @observe() hoje = ''
    @observe() carregando = false
    @observe() painel?: Painel
    @observe() erro?: string
    @observe() atalhos: Atalho[] = []

    onAtualizar = Scope.ASYNC_ACTION
    onAbrir = Scope.ASYNC_ACTION_ONE<Destino>()
}
